import { selectAuthSession } from '../../../auth/store/selectors';
import { selectOngoingCourses, selectPastCourses } from '../../../db/courses/selectors';
import { selectHomeActiveTab } from '../../../home/store/selectors';
import { HomeTabs } from '../../../home/store/types';
import { useAppSelector } from '../../../store/hooks';

export default function useNoCoursesCardVM() {
  const session = useAppSelector((state) => selectAuthSession(state));
  const name = session?.name || '';

  const activeTab = useAppSelector((state) => selectHomeActiveTab(state));
  const ongoingCourses = useAppSelector((state) => selectOngoingCourses(state));
  const pastCourses = useAppSelector((state) => selectPastCourses(state));

  const hasCourses =
    activeTab === HomeTabs.ONGOING_COURSES ? ongoingCourses.length > 0 : pastCourses.length > 0;

  return {
    name,
    hasCourses,
  };
}
